import { useEffect, useMemo } from 'react';
import { InnerBlocks, BlockControls } from '@wordpress/block-editor';
import { useSelect } from '@wordpress/data';
import PanelSettings from './advance/inspector-control';
import AdvanceSettings from './advance';
import { CopyPasteStyles } from '@vayu-blocks';
import { VayuBlocksUniqueId } from '@vayu-blocks/global';
import { getAnimationClass } from './utils/animationClass';

const edit = ({ attributes, setAttributes,clientId,isSelected}) => {

	VayuBlocksUniqueId({ setAttributes, clientId });

   const animationClass = useMemo(() => getAnimationClass(attributes.imagehvreffect, attributes.flipside, attributes.dbox),
	[attributes.imagehvreffect, attributes.flipside, attributes.dbox]);

	const ALLOWED_BLOCKS = ['vayu-blocks/flip-wrapper'];

    const image_flip_template = useMemo(() => [
        [
            'vayu-blocks/flip-wrapper',
            {
                className: `vayu_blocks_flip-box-front`,
                flipSide: 'front',
                flipBackground: {
                    color: '#b1c5a4',
                    type: 'color',
                },
                metadata: { name: 'Front' },
            },
        ],
        [
            'vayu-blocks/flip-wrapper',
            {
                className: `vayu_blocks_flip-box-back`,
                flipSide: 'back',
                flipBackground: {
                    color: '#b5bdbc',
                    type: 'color',
                },
                metadata: { name: 'Back' },
            },
        ],
    ], []);

	const innerBlocks = useSelect((select) => select('core/block-editor').getBlocks(clientId),[clientId]);

    useEffect(() => {
        if (isSelected) {
            const uniqueIds = innerBlocks.map((block) => block.attributes.uniqueId);
            setAttributes({ innerBlockUniqueIds: uniqueIds });
        }
    }, [innerBlocks, isSelected]);

    return (
		<>
			<BlockControls>
				<CopyPasteStyles
					attributes={attributes}
					setAttributes={setAttributes}
					blockName={'vayu-blocks/flip-box'}
				/>
			</BlockControls>

			<PanelSettings
				attributes={attributes}
				setAttributes={setAttributes}
				isSelected={isSelected}
				clientId={clientId}
			/>
			<AdvanceSettings
				attributes={attributes}
				setAttributes={setAttributes}
				clientId={clientId}
                isSelected={isSelected}
			>
				<div className="vb-flip-box-container">
					<div className="vb-flip-box-wrapper" >
						<div
							className={`vayu_blocks_flip-box-inner ${attributes.selectedanimation ? animationClass : ''}`}
						>
							<InnerBlocks template={image_flip_template} allowedBlocks={ALLOWED_BLOCKS} />
						</div>
					</div>
				</div>
			</AdvanceSettings>
		</>
	);
};

export default edit;